import * as React from 'react';
import {
  FlexRowCenterVertical,
  FlexColCenter,
} from '../../Defaults/Flexbox/Flexbox';
import styled, { withTheme } from 'styled-components';
import { rem, rgba } from 'polished';
import { __ } from 'react-i18n';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  currentView: string;
  changeView: () => void;
  theme: any;
  isDsi?: boolean;
}

function ViewSwitcher({ currentView, changeView, theme, isDsi }: Props) {
  const isCard = currentView !== 'list';
  const isList = !isCard;

  return (
    <Wrapper>
      <IconWrapper active={isCard} onClick={isCard ? null : changeView}>
        <SvgIcon
          viewBox="0 0 22 22"
          icon={IconType.cardView}
          title={__('Prepnutie na kartové zobrazenie')}
          alt={__('Prepnutie na kartové zobrazenie')}
          cursor={isCard ? 'initial' : 'pointer'}
          fill={isCard ? '#FFFFFF' : theme.viewSwitcher.iconColor}
        />
      </IconWrapper>
      <SecondIconWrapper active={isList} onClick={isList ? null : changeView}>
        {isDsi ? (
          <SvgIcon
            viewBox="0 0 24 24"
            icon={IconType.listView}
            title={__('Prepnutie na listové zobrazenie')}
            alt={__('Prepnutie na listové zobrazenie')}
            cursor={isList ? 'initial' : 'pointer'}
            fill={isList ? '#FFFFFF' : theme.viewSwitcher.iconColor}
          />
        ) : (
          <img
            alt={__('Zmeniť zobrazenie produktov')}
            title={__('Zmeniť zobrazenie produktov')}
            src={
              isList
                ? '/images/corporate/list-white.svg'
                : '/images/corporate/list.svg'
            }
          />
        )}
      </SecondIconWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(0)};

  ${({ theme }) => theme.mediab.m760`
   margin-left: ${rem(16)};
  `};
`;

const IconWrapper = styled(FlexColCenter)<{ active: boolean }>`
  transition: all 0.2s ease;
  cursor: pointer;
  padding: ${rem(12)};
  background-color: ${props =>
    props.active
      ? props.theme.viewSwitcher.iconBackground
      : rgba(props.theme.viewSwitcher.iconBackground, 0.04)};
  width: ${rem(47)};
  border-radius: ${rem(4)} 0 0 ${rem(4)};
`;

const SecondIconWrapper = styled(IconWrapper)`
  border-left: 0;
  border-radius: 0 ${rem(4)} ${rem(4)} 0;
`;

const WithTheme: any = withTheme(ViewSwitcher);
export { WithTheme as ViewSwitcher };
